import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {FillableForm} from './fillable-form.model';
import * as FillableFormActions from './fillable-form.actions';

export const fillableFormsFeatureKey = 'fillableForms';

export interface State extends EntityState<FillableForm> {
  // additional entities state properties
}

export const adapter: EntityAdapter<FillableForm> = createEntityAdapter<FillableForm>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(FillableFormActions.addFillableForm,
    (state, action) => adapter.addOne(action.fillableForm, state)
  ),
  on(FillableFormActions.upsertFillableForm,
    (state, action) => adapter.upsertOne(action.fillableForm, state)
  ),
  on(FillableFormActions.addFillableForms,
    (state, action) => adapter.addMany(action.fillableForms, state)
  ),
  on(FillableFormActions.upsertFillableForms,
    (state, action) => adapter.upsertMany(action.fillableForms, state)
  ),
  on(FillableFormActions.updateFillableForm,
    (state, action) => adapter.updateOne(action.fillableForm, state)
  ),
  on(FillableFormActions.updateFillableForms,
    (state, action) => adapter.updateMany(action.fillableForms, state)
  ),
  on(FillableFormActions.deleteFillableForm,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(FillableFormActions.deleteFillableForms,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(FillableFormActions.loadFillableForms,
    (state, action) => adapter.setAll(action.fillableForms, state)
  ),
  on(FillableFormActions.clearFillableForms,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
